import { FC, useState } from 'react';
import * as Icon from '../icons';

interface ConnexionFormHeaderProps {
  topLabel?: string;
  actionTopLabel?: string;
  actionTopOnClick?: () => void;
  title: string;
  subTitle?: string;
  subSubTitle?: string;
  addAppsConnect?: boolean;
}

const FormHeader: FC<ConnexionFormHeaderProps> = ({
  topLabel,
  actionTopLabel,
  actionTopOnClick,
  title,
  subTitle,
  subSubTitle,
  addAppsConnect = false,
}) => {
  const [franceConnectButtonHover, setFranceConnectButtonHover] = useState<boolean>(false);
  const fromSkemeet = localStorage.getItem('redirectUrl')?.includes(import.meta.env.VITE_SKEMEET_APP_HOST);
  const enableFranceConnect =
    import.meta.env.VITE_ACCOUNT_APP_HOST.includes('.dev') || import.meta.env.VITE_ACCOUNT_APP_HOST.includes('localhost'); //TODO remove when add france connect
  const enableProSanteConnect = true;

  const getProSanteConnectAuthenticationUrl = async () => {
    document.location.href = `${import.meta.env.VITE_ACCOUNT_API_HOST}/auth/pro-sante-connect/login`;
  };

  const getFranceConnectAuthenticationUrl = async () => {
    throw new Error('Not implemented');
    //TODO
    //document.location.href =
  };

  return (
    <div className='flex flex-col gap-8 max-2xl:gap-7'>
      {topLabel && (
        <div className='rounded-lg bg-[#EFFAF5] px-7 py-2 text-center break-words'>
          {topLabel}&nbsp;
          <span className='text-green-dark cursor-pointer font-bold hover:underline' onClick={actionTopOnClick}>
            {actionTopLabel}
          </span>
        </div>
      )}
      <div className='text-green-dark text-center text-2xl font-bold'>{title}</div>
      {subTitle && <div className='text-black-light mb-4 text-center'>{subTitle}</div>}
      {subSubTitle && <div className='text-gray-primary text-center'>{subSubTitle}</div>}
      {addAppsConnect && (
        <>
          <div className={`flex ${enableFranceConnect && !fromSkemeet ? '' : 'justify-center'} max-lg:flex-col max-lg:items-center`}>
            {enableFranceConnect && !fromSkemeet && (
              <div className='flex flex-col max-lg:w-full lg:w-3/6 lg:border-r-2'>
                <div className='text-center font-semibold'>Avec France Connect +</div>
                <button
                  className='mt-5 flex justify-center'
                  onMouseEnter={() => setFranceConnectButtonHover(true)}
                  onMouseLeave={() => setFranceConnectButtonHover(false)}
                  onClick={() => {
                    if (getFranceConnectAuthenticationUrl) {
                      getFranceConnectAuthenticationUrl();
                    }
                  }}
                >
                  <Icon.FranceConnectPlus backgroundColor={franceConnectButtonHover ? '#1212FF' : '#000091'} />
                </button>
                <div className='mt-1 mb-6 flex cursor-pointer justify-center text-[#000091] decoration-1 hover:decoration-2'>
                  <a
                    className='mx-[1rem] mt-[0.75rem] flex border-b-[1px] border-[#000091] text-center text-[0.850rem] hover:border-b-2'
                    href='https://franceconnect.gouv.fr/franceconnect-plus'
                    target='_blank'
                    rel='noreferrer'
                  >
                    <div className='flex max-xl:hidden'>
                      <span className='h-full text-[0.875rem] leading-6'>Qu&apos;est-ce que FranceConnect+ ?</span>
                      <Icon.FranceConnectWhat className='ml-1 h-full' />
                    </div>
                    <div className='flex flex-col xl:hidden'>
                      <div className='h-full text-[0.875rem] leading-6'>Qu&apos;est-ce que</div>
                      <div className='flex'>
                        FranceConnect+ ?<Icon.FranceConnectWhat className='ml-1 h-full' />
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            )}
            <div className={`flex flex-col ${enableFranceConnect && !fromSkemeet ? 'max-lg:w-full lg:w-3/6' : ''} mb-6`}>
              <div className='text-center font-semibold'>{enableProSanteConnect ? 'Avec' : 'Prochainement avec'} e-CPS</div>
              <div className='mt-5 flex justify-center'>
                <button
                  className={`w-48 ${enableProSanteConnect ? 'cursor-pointer' : 'cursor-not-allowed'}`}
                  onClick={() => {
                    if (enableProSanteConnect) {
                      if (getProSanteConnectAuthenticationUrl) {
                        getProSanteConnectAuthenticationUrl();
                      }
                    }
                  }}
                >
                  <Icon.ProSanteConnect color={enableProSanteConnect ? '#000091' : '#6F7072'} />
                </button>
              </div>
            </div>
          </div>
          <div>
            <div className='border-b-2' />
            <div className='flex justify-center'>
              <span className='text-gray-primary relative bottom-3.5 bg-white px-4 font-bold'>ou</span>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FormHeader;
